import { GridItem, Typography } from "@octopus-energy/coral/atoms"
import { useTranslations } from "next-intl"

type DashboardLayoutHomePageHeaderProps = {
    accountNumber: string
    givenName: string | undefined
}

export function DashboardLayoutHomePageHeader({
    accountNumber,
    givenName,
}: DashboardLayoutHomePageHeaderProps) {
    const t = useTranslations("DashboardLayoutHomePageHeader")

    return (
        <GridItem
            gridArea="header"
            alignSelf="center"
        >
            <Typography
                textStyle="h3"
                component="h1"
            >
                {t("greeting", { name: givenName })}
            </Typography>
            <Typography textStyle="body2">{t("accountNumber", { accountNumber })}</Typography>
        </GridItem>
    )
}

DashboardLayoutHomePageHeader.messages = ["DashboardLayoutHomePageHeader"] as const
